import { IDropdownOptions } from '@components/Dropdown/DropdownRHF';
import { Translate } from '@hooks/useI18n';
import { MerchantNoteLabel } from '@pages/MerchantDetails/tables/merchantNotes/enums';
import { missingValuePlaceholder } from '@utils/constants';
import { ILabelPermissions } from '../../tables/merchantNotes/types';

interface IGetLabelDropDownOptions {
  labelPermissions: ILabelPermissions;
  translate: Translate;
}
export const getLabelDropDownOptions = ({
  labelPermissions,
  translate,
}: IGetLabelDropDownOptions): IDropdownOptions[] => {
  return [
    { id: '', name: missingValuePlaceholder },
    ...(labelPermissions.sales
      ? [
          {
            id: MerchantNoteLabel.SALES,
            name: translate('OPS_PORTAL.LABEL.SALES'),
          },
        ]
      : []),
    ...(labelPermissions.support
      ? [
          {
            id: MerchantNoteLabel.SUPPORT,
            name: translate('OPS_PORTAL.LABEL.SUPPORT'),
          },
        ]
      : []),
  ];
};
